module.exports = __webpack_public_path__ + "images/cqssc.937c.png";